module.exports = __webpack_public_path__ + "media/images/success/dots-2e0b5a56b78ba0598ebd79face748227.png";